/**
 * AdminLayout — Wrapper que delega para o layout correto baseado na especialidade.
 *
 * - Admin principal (diligencia_especialidade = null): layout administrativo completo
 * - Admin especializado: layout enxuto e contextual
 */

import React from 'react';
import { BaseLayout } from './BaseLayout';
import { layoutConfigs } from './layoutConfigs';
import { AdminSidebar } from './AdminSidebar';
import { AdminEspecializadoLayout } from './AdminEspecializadoLayout';
import { useDiligenciaPermissions } from '@/features/diligencias/hooks';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { isAdminEspecializado } = useDiligenciaPermissions();

  if (isAdminEspecializado) {
    return (
      <AdminEspecializadoLayout>
        {children}
      </AdminEspecializadoLayout>
    );
  }

  return (
    <BaseLayout
      sidebar={<AdminSidebar />}
      config={layoutConfigs.admin}
    >
      {children}
    </BaseLayout>
  );
};
